import "./App.css";
import Home from "./Pages/Home";

function App() {
  return (
    <div className="App bg-white ">
      <header className=" text-center max-w-[90%] m-auto ">
        <Home />
      </header>
    </div>
  );
}

export default App;
